import React, { useEffect } from 'react';
import { ossixProviders } from 'queries/ossix/otherQuery';
import { ActionType } from 'types/generalType';

interface HookParams {
  ActionType?: ActionType;
  CountryCode?: string;
  IncludeSelf?: string;
  TargetType?: string;
}

export default ({
  ActionType,
  CountryCode,
  IncludeSelf,
  TargetType,
}: HookParams) => {
  const {
    ossixProvidersData,
    loadOssixProviders,
    isOssixProvidersError,
    isOssixProvidersSuccess,
    ossixProvidersMessage,
    mutate: requestProviders,
    clearData: requestClearProvider,
  } = ossixProviders();

  useEffect(
    () =>
      requestProviders({
        ActionType,
        CountryCode,
        IncludeSelf,
      }),
    [ActionType, CountryCode, IncludeSelf, requestProviders],
  );

  const providers = React.useMemo(() => {
    return (
      ossixProvidersData?.filter(
        (item: { TargetType: string; Available: string }) =>
          item?.TargetType === TargetType &&
          item?.Available === 'YES',
      ) || []
    );
  }, [ossixProvidersData, TargetType]);

  return {
    providers: providers || [],
    loadingProviders: loadOssixProviders,
    errorLoadingProviders: isOssixProvidersError,
    successLoadingProviders: isOssixProvidersSuccess,
    requestMessage: ossixProvidersMessage,
    requestClearProvider,
  };
};
